import { Autocomplete, Box, TextField } from "@mui/material";
import Blocker from "../../components/Blocker";
import { ProfessionDAO } from "../../dao/ProfessionDAO";
import { uniProfession } from "../../dao/Profession";
import { useEffect, useState } from "react";
import { OnApiError } from "../../ErrorManager";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { useTranslation } from "react-i18next";

type Props = {
  onSelectProfession?: (selectedProfession: uniProfession) => void;
};

const FrmCareerSelector: React.FC<Props> = ({ onSelectProfession }) => {
  // const { _ProfessionList } = useProfessionList(false);
  const [_ProfessionList, set_ProfessionList] = useState<
    uniProfession[] | undefined
  >(undefined); // 尚未撈資料庫時為 undefined
  const ctx = useAppContext();
  const { t } = useTranslation();

  async function refresh_ProfessionList() {
    try {
      let re = await ProfessionDAO.WS_SelectAllProfession();
      set_ProfessionList(re);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  }

  useEffect(() => {
    refresh_ProfessionList();
  }, []);

  function handleSelectOption(selectedOption: uniProfession | null) {
    if (selectedOption && onSelectProfession) {
      onSelectProfession(selectedOption);
    }
  }

  function render_AutoComplete() {
    if (_ProfessionList === undefined) {
      return <Blocker />;
    }
    const groups: { [key: string]: string } = {};
    const options: uniProfession[] = [];

    _ProfessionList.forEach((option) => {
      if (option.professionCode.length === 6) {
        options.push(option);
      }
      if (option.professionCode.length === 4) {
        const groupKey = option.professionCode;
        if (!groups[groupKey]) {
          groups[groupKey] = option.professionName;
        }
      }
    });

    return (
      <Autocomplete
        id="grouped-demo"
        options={options}
        groupBy={(option) => {
          const groupKey = option.professionCode.substring(0, 4);
          return groups[groupKey] ? t(groups[groupKey]) : "";
        }}
        getOptionLabel={(option) => t(option.professionName)}
        onChange={(event, newValue) => handleSelectOption(newValue)}
        sx={{ width: 300 }}
        renderInput={(params) => (
          <TextField {...params} label={t("請選擇職業")} />
        )}
      />
    );
  }

  return (
    <div style={{ position: "sticky" }}>
      <Box sx={{ height: 300, flexGrow: 1, maxWidth: 800, overflowY: "auto" }}>
        {render_AutoComplete()}
      </Box>
    </div>
  );
};

export default FrmCareerSelector;
